import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function HandHoldingCoinMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M8.04 21.01c1.032.575 2.328.72 3.96-.025l8.832-4.032a2.553 2.553 0 001.488-2.304c0-1.44-1.176-2.496-2.52-2.496-.216 0-.432.024-.648.096l-.072-.144c-.576-1.08-1.896-1.512-3.048-.984l-1.464.672c.408.384.744.864.96 1.392l1.2-.528a.683.683 0 01.936.36l.096.216-3.384 1.536c0-1.008-.6-1.944-1.512-2.376l-3.96-1.848C6.24 9.297 3.696 9.825 1.68 12.25v6.696h1.8v-6c1.368-1.368 2.88-1.584 4.656-.768l3.96 1.848c.288.144.48.432.48.768 0 .6-.648 1.008-1.176.768l-3.072-1.416-.6 1.296 3.456 1.608c.528.24 1.2.192 2.112-.216l6.216-2.808c.48-.216 1.008.12 1.008.624a.765.765 0 01-.432.672l-8.832 4.032c-.936.432-1.656.456-2.352.072l-2.712-1.512-.888 1.584L8.04 21.01zM8.4 6.104c0 1.992 1.608 3.6 3.6 3.6s3.6-1.608 3.6-3.6-1.608-3.6-3.6-3.6a3.595 3.595 0 00-3.6 3.6zm1.68 0c0-1.056.864-1.92 1.92-1.92s1.92.864 1.92 1.92-.864 1.92-1.92 1.92a1.926 1.926 0 01-1.92-1.92z"  /></Svg>;
}
export default HandHoldingCoinMedium;